export const sharedEnvironment = {
  production: true,
  firebase: {
    //apiKey: 'AIzaSyCFCyF62JXiQ39DawQU2880Y2dzdBanepQ',
    //authDomain: 'dixper-abae2.firebaseapp.com',
    //databaseURL: 'https://dixper-abae2.firebaseio.com',
    //storageURL: 'https://firebasestorage.googleapis.com',
    //projectId: 'dixper-abae2',
    //storageBucket: 'dixper-abae2.appspot.com',
    //messagingSenderId: '398186278784',
    //appId: '1:398186278784:web:9e91eccdf32ecc22',
    //measurementId: 'G-HKEGKNYP0V',
    apiKey: 'AIzaSyCeiNtchGxC4vYYBmdhpdoldkOlC52VVJg',
    authDomain: 'dixperprimaris.firebaseapp.com',
    databaseURL: 'https://dixperprimaris-default-rtdb.firebaseio.com',
    projectId: 'dixperprimaris',
    storageBucket: 'dixperprimaris.firebasestorage.app',
    messagingSenderId: '367611659723',
    appId: '1:367611659723:web:b9816e4c0295a64267a24e',
    measurementId: 'G-T3603XKCLC',
  },
  googleCloud: {
    FONT_API: 'AIzaSyB3zlLj369ho9tJMbbfvvk0tybMprW3wxA',
    RECAPTCHA: '6LflQXQUAAAAAAVmHBxtGacp1kge4pUTFBGkSRsp',
  },
  sentry: {
    enable: false,
    tracesSampleRate: 0.1,
    autoSessionTracking: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['https://challenges-dot-dixper-abae2.uc.r.appspot.com', 'https://api-dot-dixper-abae2.uc.r.appspot.com'],
  },

  'legals-en': {
    terms: 'https://www.notion.so/dixper/General-Terms-and-Conditions-c14543cb9585408a96f56f36ae9c7b07',
    privacy: 'https://www.notion.so/dixper/Privacy-Policy-46090bb679ac443f8b82fe2b08c8014b',
    notice: 'https://www.notion.so/dixper/Legal-Notice-fe5e92cf472647c396c22eb2b095b152',
    cookies: 'https://www.notion.so/dixper/Cookies-Policy-f793870d7fd34a8f8a86ef286eb3bc53',
  },

  'legals-es': {
    terms: 'https://www.notion.so/dixper/T-rminos-y-Condiciones-abf94f1e110d4f3ab1a44a20f92e694f',
    privacy: 'https://www.notion.so/dixper/Pol-tica-de-Privacidad-d022fce7f5204e308bc64bcc55101f94',
    notice: 'https://www.notion.so/dixper/Aviso-Legal-1651e102c39c43dcae04851120d42bf0',
    cookies: 'https://www.notion.so/dixper/Pol-tica-de-Cookies-ba17460067384364b8783acc461e88c3',
  },
  host: 'https://beta.dixper.gg',
  //host: 'http://localhost:4200',
  twitch: {
    clientId: '7fwfyf770mn6tcs601mwvu3q5ia07m',
    clientSecret: 'ufkspzvqrsne38rzuetbiegodcam1u',
    //redirectUri: 'http://localhost:4200',
    //redirectUri: 'http://localhost:5500',
    redirectUri: 'https://beta.dixper.gg/',
    redirectUriStudio: 'https://beta.dixper.gg/login-studio',
  },
  youtube: {
    redirectUri: 'https://beta.dixper.gg/u/accounts',
  },
  engine: 'sinanju',
  discordUrl: 'https://discord.gg/ctwzZVq',
  streamingPlatforms: {
    twitch: 'https://www.twitch.tv',
    twitchPlayer: 'https://player.twitch.tv',
    youtube: 'https://www.youtube.com',
  },
  socialMediaPlatforms: {
    twitch: 'https://www.twitch.tv',
    youtube: 'https://www.youtube.com',
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    twitter: 'https://www.twitter.com',
    tiktok: 'https://www.tiktok.com',
  },
  api: {
    url: 'https://dixper-api-pro-dot-dixperprimaris.uc.r.appspot.com/api',
  },
  hosts: {
    widget: 'https://overlays.beta.dixper.gg', // PROD
    challengesUi: 'https://challenges-ui-dot-dixper-abae2.uc.r.appspot.com/',
  },
  searchEngine: {
    host: 'https://search-beta.dixper.gg',
    apiKey: 'zZxZSQn5Dv8mfuDC0bbrVHYZQOYNREA3G8uZMR6v+vQ=',
  },
  ws: {
    url: 'https://dixper-ws-dev-dot-dixperprimaris.uc.r.appspot.com',
    options: {
      path: '/websocket/socket.io',
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5,
      autoConnect: false,
      transports: ['polling', 'websocket'],
    },
  },
  notion: {
    assets: 'https://www.notion.so/dixper/Dixper-Asset-Gallery-f3aafdfefb744823a79b720643d4e448',
    helpCenter: 'https://dixper.notion.site/Dixper-Help-Center-5d58baa2a49e41f5aa313b140a29a122',
  },
  common: {
    enginePingInterval: 20000,
    enginePingTimeout: 10000,
  },
  braintree: {
    merchant_id: 'd265y89kw2wsrmy9',
  },
};
